import React from 'react';
import {compose} from 'redux';
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {Form, Input, InputNumber} from 'antd';
import _ from "lodash";
import {changeAppConfigEndpointSettingsForm} from "./actions";

const mapStateToProps = state => ({
  EndpointSetting: state.scenes.configuration.appConfig.config.EndpointSetting
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeAppConfigEndpointSettingsForm(fields))
});

const mapPropsToFields = ({EndpointSetting}) => ({
  NsiTimeOut: Form.createFormField({value: EndpointSetting !== null ? EndpointSetting.NsiTimeOut : null}),
  DmTimeOut: Form.createFormField({value: EndpointSetting !== null ? EndpointSetting.DmTimeOut : null}),
  MaTimeOut: Form.createFormField({value: EndpointSetting !== null ? EndpointSetting.MaTimeOut : null})
});

const onFieldsChange = (props, fields) => props.onChange(_.mapValues(fields, ({value}) => value));

const EndpointSettingsForm = ({
                                t,
                                form
                              }) =>
  <Form>
    <Form.Item
      label={t("data.appConfig.endpointSettingsForm.nsiTimeOut.label")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      {form.getFieldDecorator("NsiTimeOut")(
        <Input
          title={form.getFieldValue("NsiTimeOut")}
        />
      )}
    </Form.Item>
    <Form.Item
      label={t("data.appConfig.endpointSettingsForm.dmTimeOut.label")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      {form.getFieldDecorator("DmTimeOut")(
        <InputNumber
          title={form.getFieldValue("DmTimeOut")}
          min={0}
          style={{width: "100%"}}
        />
      )}
    </Form.Item>
    <Form.Item
      label={t("data.appConfig.endpointSettingsForm.maTimeOut.label")}
      className="form-item-required"
      style={{marginBottom: 0}}
    >
      {form.getFieldDecorator("MaTimeOut")(
        <InputNumber
          title={form.getFieldValue("MaTimeOut")}
          min={0}
          style={{width: "100%"}}
        />
      )}
    </Form.Item>
  </Form>;

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(EndpointSettingsForm);
